// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"TW-z","sponsoredTooltipWrapper":"UW-z","sponsoredTooltip":"VW-z","newCard":"WW-z"};